<template>
  <div>
    <Top />
    <div class="content">
      <!-- 选项 -->
      <ul class="param__ul clearfix">
        <li class="param__li fl" @click="funMenuSelect(1)">
          <span>显示数据</span>
        </li>
        <li class="param__li fl" @click="funMenuSelect(2)">
          <span>转换行列</span>
        </li>
        <li class="param__li fl" @click="funMenuSelect(3)">
          <span>隐藏空行</span>
        </li>
        <li class="param__li fl" @click="funMenuSelect(4)">
          <span>隐藏空列</span>
        </li>
        <li class="param__li fl" id="btnCopyTableDataText" @click="funMenuSelect(5)">
          <span>复制</span>
        </li>
        <li class="param__li fl" @click="funMenuSelect(6)">
          <span>导出数据</span>
        </li>
        <li class="param__li fl" @click="funMenuSelect(7)">
          <span>显示图形</span>
        </li>
        <router-link v-show="isShow" :to="{name:'trade'}" class="param__li fr">
          <span>返回</span>
        </router-link>
      </ul>

      <!-- 内容 -->
      <div class="mainarea clearfix">
        <!-- 左侧 -->
        <div class="pull-left fl">
          <el-menu class="equ__height">
            <el-menu-item
              v-for="item in dimensionList"
              :key="item.idFiled"
              @click="showDimensionValues(item.dimension,item.idFiled)"
              :class="'dcode-'+item.idFiled"
            >{{item.dimension}}</el-menu-item>
          </el-menu>
        </div>
        <!-- 右侧 -->
        <div class="pull-right fl">
          <!-- 表格 -->
          <div id="mytable" v-show="tableShow">
            <table class="data-table" id="table_data"></table>
          </div>
          <!-- 维度值选择 -->
          <div class="dimension clearfix" v-show="dimensionShow">
            <!-- 左侧 -->
            <div class="dimension_left fl">
              <div class="select-box">
                <span>{{currentDimensionName}}：</span>
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                >全选</el-checkbox>
                <!-- 搜索开始 -->
                <div class="searchkeys" id="searchkeys">
                  <input
                    class="input"
                    type="text"
                    v-model="paramSearch"
                    v-show="currentDimensionCode != 'time_id'"
                    v-on:keyup.enter="querySearchAsync"
                  />
                  <el-button
                    @click="querySearchAsync"
                    v-show="currentDimensionCode != 'time_id'"
                    id="search--bg"
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    style="margin-left: -1%; width: 17%;"
                  ></el-button>
                  <!-- 搜索结果 -->
                  <div class="input_result" id="myPanel" v-show="panelShow">
                    <div class="popper__arrow"></div>
                    <ul>
                      <div v-show="none" style="color:#606266">无匹配数据</div>
                      <el-checkbox-group v-show="have" v-model="checkList">
                        <el-checkbox
                          @change="changeSearchcheckbox($event,item)"
                          v-for="item in restaurants"
                          :key="item.id"
                          :label="item"
                          :title="item.displayName"
                        >{{item.name}}</el-checkbox>
                      </el-checkbox-group>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="tree-box">
                <!-- expand-on-click-node:是否在点击节点的时候展开或者收缩节点 -->
                <!-- check-on-click-node:是否在点击节点的时候选中节点，默认值为 false -->
                <!-- check-strictly:在显示复选框的情况下，是否严格的遵循父子不互相关联的做法 -->
                <!-- auto-expand-parent:展开子节点的时候是否自动展开父节点 -->
                <!-- render-after-expand:是否在第一次展开某个树节点后才渲染其子节点 -->
                <!-- show-checkbox:节点是否可被选择 -->
                <!-- check-change:节点选中状态发生变化时的回调 -->
                <!-- node-expand:节点被展开时触发的事件 -->
                <!-- node-click:节点被点击时的回调 -->
                <!-- :default-checked-keys="treeDefaultCheckedKeys" -->
                <el-tree
                  id="tree-dimension"
                  v-loading="loading"
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :props="treeProps"
                  :data="treeNodes"
                  :expand-on-click-node="true"
                  :check-on-click-node="true"
                  :check-strictly="true"
                  :auto-expand-parent="true"
                  :render-after-expand="false"
                  :load="loadNode"
                  lazy
                  show-checkbox
                  @check-change="handleCheckChange"
                  @node-expand="handleNodeExpand"
                  @node-click="handleNodeExpand"
                ></el-tree>
              </div>
            </div>

            <!-- 右侧 -->
            <div class="dimension_right fl">
              <div
                style="background:#fff;margin-bottom: 10px;padding: 11px 15px 10px;text-align: left;"
              >
                <span>已选{{currentDimensionName}}：</span>
                <!-- <el-checkbox
                  :indeterminate="isCheckedIndeterminate"
                  v-model="checkedCheckAll"
                  @change="handleCheckedCheckAllChange"
                >全选</el-checkbox>-->
                <!-- <span class="icon-del" @click="handleRemoveChecked">删除</span> -->
                <span class="icon-clear" @click="handleClearAllChecked">清空</span>
              </div>
              <div
                class="checkednode-box"
                style="background: #fff;height: 93%;overflow: auto;padding: 10px 5px;"
              >
                <el-checkbox-group
                  style="padding-top:5px;width:130px;text-align:left;margin-left:24px;"
                  v-model="checkedOptions"
                >
                  <el-checkbox
                    v-for="(item,index) in checkedNodes"
                    :key="index"
                    :label="item"
                    @change="changeCheckbox($event,item)"
                    style="padding:3px 0"
                  >{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 弹框 -->
      <!-- 转换行列弹窗 -->
      <el-dialog
        center
        title="转换行列"
        :visible.sync="dialogChangeRowColumn"
        width="50%"
        id="savequery--model"
      >
        <div style="width:80%;margin:0 auto;">
          <el-transfer v-model="transferChecked" :data="transferData" :titles="['行信息', '列信息']"></el-transfer>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogChangeRowColumn = false">取 消</el-button>
          <el-button type="primary" @click="transposeRowColumn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 画图 -->
      <el-dialog id="chartlog" :visible.sync="chartShows" width="1000px">
        <dtChart ref="mychilds" :chartdata="changeChartData"></dtChart>
      </el-dialog>
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
import dtChart from "@/components/DrawEcharts";
import FileSaver from "file-saver";
import { api } from "@/require/api";
import $ from "jquery";
import FactValueBLL from "@/utils/dataFactValue.js";
import ClipboardJS from "clipboard";
import XLSX from "xlsx";
import axios from "axios";

export default {
  components: {
    Top,
    dtChart,
    Footer
  },
  data() {
    return {
      dimensionList: [], //  获取左侧维度值和对应的默认选择的值---(data赋值)
      firstparamList: [],
      paramList_trade: {},
      paramList_trade_last: {}, // 传给贸易数据库的接口参数
      paramList: [], // （接口list的参数）
      uid: "", // （接口list的参数）
      dimensionCodeText: [], // 左侧维度名称集合---(应用于数据格式转化)
      rowDimensionCode: "", // 行上的维度string
      columnDimensionCode: "", // 列上的维度string
      defaultCheckedDimensionValues: {}, // 初始默认选中维度值---(应用于数据格式转化)

      factValueBLL: null,
      matrix: null,
      filterArray: null,

      tableShow: true,
      dimensionShow: false,
      dialogChangeRowColumn: false, // 行列转换
      transferChecked: [],
      transferData: [],
      changeChartData: {
        // 画图
        legend: [],
        xAxis: [],
        series: []
      },
      chartShows: false,
      // ---------------------------------------- 华丽分割线
      checkAll: false, // 选择
      isIndeterminate: true,
      currentDimensionName: "", // 当前的维度Name
      currentDimensionCode: "", // 当前的维度Code
      loading: false,
      treeNodes: [],
      treeProps: {
        label: "name",
        children: "childList",
        isLeaf: "leaf"
      },
      // 【控制维度选择数量】
      sumDimensionNum: 0,
      currentDimensionNum: 1,
      // 【右侧】
      checkedOptions: [],
      checkedNodes: [],
      // 【搜索】
      //参数查询数据
      paramSearch: "",
      panelShow: false,
      have: false,
      none: false,
      checkList: [],
      restaurants: [],
      isShow: false
    };
  },
  created() {
    this.uid = this.$route.query.uid;
    if (this.uid === "-8012" || this.uid === -8012) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
    this.defaultStruct();
    this.hide();
    // console.log(this.uid === -8012)
    // ((this.uid === '-8012') || (this.uid === -8012)) ? this.isShow = true : this.isShow = false
  },
  mounted() {},
  computed: {},
  watch: {
    $route(to, from) {
      this.uid = to.query.uid;
      if (this.uid === "-8012" || this.uid === -8012) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      this.defaultStruct();
      //  ((this.uid === '-8012') || (this.uid === -8012)) ? this.isShow = true : this.isShow = false
    }
    // checkedNodes:{
    //   handler:function(newval, oldval){
    //     let DimensionNum = 1
    //     Object.entries(this.defaultCheckedDimensionValues).forEach(item => {
    //       DimensionNum *= item[1].length
    //     })
    //     this.currentDimensionNum = DimensionNum
    //     console.log(this.currentDimensionNum,this.sumDimensionNum)
    //     if(this.currentDimensionNum > this.sumDimensionNum){
    //       this.$message({
    //         message: "查询的维度已达上限",
    //         type: "warning"
    //       });
    //       return
    //     }
    //   },
    // },
  },
  methods: {
    // 获取左侧纬度值和对应的默认选择的值,拼接接口/list的参数
    async defaultStruct() {
      this.showFactTable();
      const { code, data } = await api.get(`/data/dimension/${this.uid}`);
      if (code === 0) {
        //  赋值dimensionList
        this.sumDimensionNum = data.querySum;
        this.dimensionList = data.deList;
        this.firstparamList = [];
        this.paramList = [];
        this.paramList_trade = {};
        this.dimensionCodeText = [];
        this.defaultCheckedDimensionValues = {};
        // console.log(this.dimensionList, "dimensionList");
        //  赋值paramList
        // [{dimensionName: "indicator_id",dimensionValue: "2,10,15,6,7"}]
        this.dimensionList.forEach(item => {
          this.firstparamList.push({
            dimensionCode: item.idFiled,
            dimensionName: item.dimension,
            dimensionArray: item.defaultValues,
            dimensionValue: "",
            dimensionFactName: ""
          });
        });
        for (let i = 0; i < this.firstparamList.length; i++) {
          for (
            let j = 0;
            j < this.firstparamList[i].dimensionArray.length;
            j++
          ) {
            this.firstparamList[i].dimensionValue +=
              "," + this.firstparamList[i].dimensionArray[j].id;
          }
          this.firstparamList[i].dimensionValue = this.firstparamList[
            i
          ].dimensionValue.slice(1);
        }
        this.firstparamList.forEach(item => {
          this.paramList.push({
            dimensionName: item.dimensionCode,
            dimensionValue: item.dimensionValue
          });
        });

        // console.log(this.paramList, "paramList");

        //  赋值paramList_trade，paramList_trade_last
        this.dimensionList.forEach(item => {
          let idFiled = item.idFiled;
          this.paramList_trade[idFiled] = item.defaultValues;
        });
        Object.entries(this.paramList_trade).forEach(item => {
          let everyItem = [],
            neweveryItem = [];
          item[1].forEach(element => {
            everyItem.push(element.displayName);
          });
          everyItem.forEach(ele => {
            neweveryItem.push(
              ele
                .substr(ele.indexOf(".") + 1)
                .replace(".", ",")
                .replace("[", "")
                .replace("]", "")
                .replace("[", "")
                .replace("]", "")
            );
          });
          this.paramList_trade[item[0]] = neweveryItem;
        });
        Object.entries(this.paramList_trade).forEach(item => {
          if (item[0].indexOf("id") !== -1) {
            this.paramList_trade_last[item[0].replace("id", "name")] = item[1];
          }
        });
        this.firstparamList.forEach(item => {
          this.paramList_trade_last[item.dimensionCode] = item.dimensionValue;
        });
        // this.firstparamList.forEach(item => {
        //   this.paramList_trade_last[item.dimensionCode] = item.dimensionValue
        // })
        // this.firstparamList.forEach(item => {
        //   this.paramList_trade[item.dimensionFactName] = item.dimensionValue
        // })
        // this.paramList_trade.forEach(item => {
        //   this.paramList_trade_last[item.]
        // })
        // for(let i in this.paramList_trade){
        //   console.log(i+','+this.paramList_trade[i])
        // }
        // var obj = {'0':'a','1':'b','2':'c'};
        // Object.keys(this.paramList_trade).forEach(function(key){
        //      console.log(key,this.paramList_trade[key],'xiao');
        // });
        // for (let i = 0; i < this.firstparamList.length; i++) {
        //   for (let j = 0;j < this.firstparamList[i].dimensionArray.length;j++) {
        //     this.firstparamList[i].dimensionFactName +="," + this.firstparamList[i].dimensionArray[j].name;
        //   }
        //   this.firstparamList[i].dimensionFactName = this.firstparamList[i].dimensionFactName.slice(1);
        // }
        // this.firstparamList.forEach(item => {
        //   if (item.dimensionCode === 'time_id') {
        //     this.paramList_trade.push({
        //       dimensionName: item.dimensionCode,
        //       dimensionValue: item.dimensionValue,
        //       dimensionFactName: item.dimensionValue
        //     });
        //   }else{
        //     this.paramList_trade.push({
        //       dimensionName: item.dimensionCode,
        //       dimensionValue: item.dimensionValue,
        //       dimensionFactName: item.dimensionFactName
        //     });
        //   }
        // });
        // console.log(this.firstparamList, "firstparamList");

        // console.log(this.paramList_trade, "paramList_trade");
        // console.log(this.paramList_trade_last,'paramList_trade_last')

        // 赋值dimensionCodeText(应用于数据格式转化)
        // [['region_id','地区'],['time_id','时间'],['indicator_id','指标']]
        this.dimensionList.forEach(item => {
          this.dimensionCodeText.push([item.idFiled, item.dimension]);
        });
        // console.log(this.dimensionCodeText, "dimensionCodeText");

        // 赋值 rowDimensionCode，columnDimensionCode
        this.rowDimensionCode = "time_id";
        let column = [];
        this.dimensionList.forEach(item => {
          if (item.idFiled !== this.rowDimensionCode) {
            column.push(item.idFiled);
          }
        });
        this.columnDimensionCode = column.join(",");
        // console.log(this.columnDimensionCode, "columnDimensionCode");

        // 赋值 defaultCheckedDimensionValues
        this.dimensionList.forEach(item => {
          this.defaultCheckedDimensionValues[item.idFiled] = item.defaultValues;
        });
        // console.log(this.defaultCheckedDimensionValues, "defaultCheckedDimensionValues");
      }
      // 判断structrueId是什么决定传参paramList
      if (this.uid === "-8012" || this.uid === -8012) {
        this.defalutDatalist(
          "/tradeController/queryGrid",
          this.paramList_trade_last
        );
      } else {
        this.defalutDatalist("/data/result/list", this.paramList);
      }
    },
    // 获取表格数据 /data/result/list /tradeController/queryGrid
    async defalutDatalist(resultURL, param) {
      const { code, data } = await api.post(resultURL, {
        dimensionList: param,
        structrueId: this.uid
      });
      console.log(data,'fata')
      if (code === 0) {
        this.tableShow = true;
        if (data === null) {
          $("#table_data")
            .empty()
            .html(
              '<tr><td style="text-align:center;padding:30px;">暂无查询数据</td></tr>'
            );
          return;
        }
        if (data.list.length == 0) {
          $("#table_data")
            .empty()
            .html(
              '<tr><td style="text-align:center;padding:30px;">暂无查询数据</td></tr>'
            );
          return;
        }
        //  生成表格需要的数据
        let factValues = new Array(), // 生成表格需要的数值数据
          dimensionValueInfos = new Array(), // 生成表格需要的维度值信息
          factValueId,
          dimensionCode,
          dimensionValueId, // 维度值ID
          dimensionValueNameField, // 维度值名称属性 如：time_name
          dimensionValues = [], // 已选维度值信息
          factData = data.list;
          console.log(this.dimensionCodeText,'this.dimensionCodeText')
        // 数据格式转化
        for (let i = 0, len = factData.length; i < len; i++) {
          factValueId = "";
          for (let d = 0; d < this.dimensionCodeText.length; d++) {
            dimensionCode = this.dimensionCodeText[d][0];
            dimensionValueId = factData[i][dimensionCode];
            factValueId += "_" + dimensionCode + ":" + dimensionValueId;
            if (
              dimensionValueInfos.filter(
                x =>
                  x.DimensionCode == dimensionCode && x.Id == dimensionValueId
              ).length == 0
            ) {
              dimensionValueNameField = dimensionCode.replace(/_id/g, "_name");
              dimensionValues =
                this.defaultCheckedDimensionValues[dimensionCode] == undefined
                  ? []
                  : this.defaultCheckedDimensionValues[dimensionCode].filter(
                      f => f.id == dimensionValueId
                    );
              dimensionValueInfos.push({
                Id: dimensionValueId,
                Name: factData[i][dimensionValueNameField],
                DimensionCode: dimensionCode,
                Explanation:
                  dimensionValues.length > 0
                    ? dimensionValues[0].description
                    : "",
                OrderNumber:
                  dimensionValues.length > 0
                    ? dimensionValues[0].orderNumber
                    : parseInt(dimensionValueId)
              });
            }
          }
          factValues.push({
            Id: factValueId + "_userdata:false_",
            FactValue: factData[i].value,
            UserData: 0,
            OrderNumber: factData[i].orderNumber
          });
        }

        this.factValueBLL = FactValueBLL.createNew();
        // 指定X轴默认维度
        this.factValueBLL.setXAxisDimensionCode(this.rowDimensionCode);
        // 初始化维度集合
        this.factValueBLL.initCodeText(this.dimensionCodeText);
        // 初始化维度值信息
        this.factValueBLL.initDimensions(dimensionValueInfos);
        // 初始化数据集
        this.factValueBLL.init(factValues);
        // 输出表格
        this.printDataTable(0);
      }
    },

    //  输出数据表格
    printDataTable: function(dataType) {
      $("#table_data").empty();
      // dataType==1 清除计算
      if (dataType === 0) {
        this.matrix = null;
        this.matrix = this.factValueBLL.createMatrix(
          this.rowDimensionCode,
          this.columnDimensionCode,
          this.filterArray,
          true
        );
        // console.log(this.matrix,'matrix')
        this.matrix.sort(0, true);
        // 保留第一次表格数据，并且按照第一次数据绘制图形
        let newChartData = this.factValueBLL.createChartInfo(this.matrix);
        // 初始化画图表的数据
        this.changeChartData.legend = [];
        this.changeChartData.xAxis = [];
        this.changeChartData.series = [];
        if (this.uid === "-8012" || this.uid === -8012) {
          this.changeChartData.xAxis = newChartData.xAxis;
          let matrix_special = getObjectValues(this.matrix);
          // console.log(matrix_special,'long')
          function getObjectValues(object) {
            let values = [];
            for (let property in object) values.push(object[property]);
            return values;
          }

          let sorry = "",
            newSorry = [];
          for (let j = 1; j < matrix_special[13][0].length; j++) {
            sorry = "";
            for (let i = 0; i < matrix_special[13].length; i++) {
              sorry = sorry + ":" + matrix_special[13][i][j].name;
            }
            sorry = sorry.substr(1);
            newSorry.push(sorry);
          }
          // console.log(newSorry,'Newsorry')
          this.changeChartData.legend = newSorry;

          let yes = [],
            newYes = [];
          for (let j = 1; j < matrix_special[12][0].length; j++) {
            yes = [];
            for (let i = 0; i < matrix_special[12].length; i++) {
              yes.push(matrix_special[12][i][j].FactValue);
            }
            newYes.push(yes);
          }
          // console.log(newYes,'newYes')
          this.changeChartData.series = newYes;
        } else {
          this.changeChartData.legend = newChartData.seriesText;
          this.changeChartData.xAxis = newChartData.xAxis;
          this.changeChartData.series = newChartData.seriesData;
        }
      } else if (dataType === 1) {
        this.matrix = null;
        this.matrix = this.factValueBLL.createMatrix(
          this.rowDimensionCode,
          this.columnDimensionCode,
          this.filterArray,
          true
        );
        this.matrix.sort(0, true);
      }

      let headerHtml = this.factValueBLL.printMatrixHeader(this.matrix);
      $("#table_data").append(headerHtml);

      // this.matrix.sort(0, true);
      let dataHtml = this.factValueBLL.printMatrixData(this.matrix);
      $("#table_data").append(dataHtml);

      this.sort();
      //   this.indicatorIntro();
      //   this.clearRowColData();
      //   this.resizeMainAreaHeight();
    },
    // 显示数据表
    showFactTable() {
      // if (this.factShow) return;
      this.tableShow = true;
      this.chartShow = false;
      this.dimensionShow = false;
    },
    // 排序
    sort() {
      let sort_matrix = this.matrix;
      let sort_factValueBLL = this.factValueBLL;
      let colDataSort = function(col, obj) {
        $("tr.datarow").detach();
        let asc = true;
        if ($(obj).attr("datasort") == undefined) {
          asc = true;
          $(obj).attr("datasort", "true");
        } else {
          asc = false;
          $(obj).removeAttr("datasort");
        }
        sort_matrix.sort(col, asc);
        let dataHtml = sort_factValueBLL.printMatrixData(sort_matrix);
        $("#table_data").append(dataHtml);
      };
      $("#table_data .icon-datasort").bind("click", function() {
        colDataSort(parseInt($(this).attr("data-col")), $(this));
      });
    },
    // ================================================================================华丽分割线
    // 获取维度值
    async defalutDimension(parentId, dinfo, resolve) {
      let _this = this;
      // this.treeNodes= []
      let pNode;
      const { code, data } = await api.get(
        `/data/dimension/child/${this.uid}`,
        {
          parentId: parentId,
          idFiled: dinfo,
          defaultIds: 0,
          openStatus: 0
        }
      );
      if (code === 0) {
        this.loading = false;
        if (data == null) return;
        // 禁用叶子结点
        data.forEach(item => {
          if (item.isLeaf === 1) {
            item.leaf = true; //返回数据isLeaf==1表示叶子节点
          } else {
            item.leaf = false;
          }
          if (item.isValued !== 1) {
            item.disabled = true;
          }
        });
        // 获取父节点
        if (parentId == 0) {
          this.treeNodes = data;
        } else {
          // 获取子节点
          // allTreeSelected = _this.$refs.tree.getCheckedNodes(); // 获取当前选中项
          let findTreeNode = function(id, items) {
            if (items != null)
              for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (item.id == id) {
                  pNode = item;
                  break;
                } else if (item.childList) {
                  findTreeNode(id, item.childList);
                }
              }
          };
          findTreeNode(parentId, this.treeNodes);
          if (pNode != undefined) pNode.childList = data;
        }
        resolve && resolve(data);
        setTimeout(() => {
          this.$refs.tree.setCheckedNodes(
            this.defaultCheckedDimensionValues[this.currentDimensionCode]
          );
        }, 500);
        // if(!allTreeSelected) return;
        // _this.$refs.tree.setCheckedNodes(allTreeSelected);
      }
    },
    // 【点击左侧显示维度】
    showDimensionValues(name, code) {
      this.treeNodes = [];
      // console.log(this.defaultCheckedDimensionValues,'点击左侧')
      this.currentDimensionName = name;
      this.currentDimensionCode = code;
      this.defalutDimension(0, code);
      // 右侧显示维度 和 左侧选择维度

      this.checkedNodes = this.defaultCheckedDimensionValues[code];
      this.checkedOptions = this.checkedNodes;

      this.tableShow = false;
      this.dimensionShow = true;
    },
    // 维度值树加载
    loadNode(node, resolve) {
      if (node.level == 0) {
        return resolve(this.treeNodes);
      } else {
        this.defalutDimension(node.data.id, this.currentDimensionCode, resolve);
      }
    },

    // 【左侧-】
    // 全选
    findChildrenValuedNode(data) {
      if (data == null) return;
      data.forEach(n => {
        if (
          n.isValued == 1 &&
          this.checkedNodes.findIndex(cked => cked.id == n.id) < 0
        )
          this.checkedNodes.push(n);
        this.findChildrenValuedNode(n.childList);
      });
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      if (val) {
        this.treeNodes.forEach(item => {
          if (
            item.isValued == 1 &&
            this.checkedNodes.findIndex(cked => cked.id == item.id) < 0
          )
            this.checkedNodes.push(item);
          this.findChildrenValuedNode(item.childList);
        });
        this.checkedNodes.forEach(c => {
          if (this.checkedOptions.findIndex(n => n.id == c.id) < 0)
            this.checkedOptions.push(c);
        });

        let defValues =
          this.checkedNodes.length > 0 ? this.checkedNodes.map(d => d.id) : [];
        this.$refs.tree.setCheckedKeys(defValues);
      } else {
        this.checkedNodes = [];
        this.checkedOptions = [];
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    // 节点选中状态发生变化时
    handleCheckChange(data, checked) {
      let newCheckedNodes = [];
      if (checked) {
        // 数组去重(newCheckedNodes-默认值加用户选择的维度)
        let firstCheckedNodes = this.$refs.tree
          .getCheckedNodes()
          .concat(this.checkedNodes);
        let hash = {};
        newCheckedNodes = firstCheckedNodes.reduce((preVal, curVal) => {
          hash[curVal.id]
            ? ""
            : (hash[curVal.id] = true && preVal.push(curVal));
          return preVal;
        }, []);

        this.defaultCheckedDimensionValues[
          this.currentDimensionCode
        ] = newCheckedNodes;
        this.checkedNodes = newCheckedNodes;
        this.checkedOptions = this.checkedNodes;
      } else {
        this.defaultCheckedDimensionValues[this.currentDimensionCode].forEach(
          (item, index, arr) => {
            if (data.id === item.id) {
              arr.splice(index, 1);
            }
          }
        );
        this.checkedNodes = this.defaultCheckedDimensionValues[
          this.currentDimensionCode
        ];
        this.checkedOptions = this.checkedNodes;
      }
    },
    handleNodeExpand() {},
    // 【 右侧- 】
    // 全选
    // handleCheckedCheckAllChange(val){
    //   // this.expandNode=undefined;
    //   this.isCheckedIndeterminate = false;
    //   if (val) {
    //     this.checkedNodes.forEach(item =>{
    //       item.isSelect = 1
    //     })
    //     this.checkedOptions = [];
    //     this.checkedNodes.forEach(n=>{
    //         this.checkedOptions.push(n);
    //     });
    //     this.defaultCheckedDimensionValues[this.currentDimensionCode] = this.checkedNodes
    //     this.checkedCheckAll = true
    //   } else {
    //       this.checkedNodes.forEach(item =>{
    //         item.isSelect = 0
    //       })
    //       this.defaultCheckedDimensionValues[this.currentDimensionCode] = this.checkedNodes
    //       this.checkedOptions = [];
    //       this.checkedCheckAll = false
    //   }
    // },
    changeCheckbox(checked, element) {
      this.defaultCheckedDimensionValues[this.currentDimensionCode].forEach(
        (item, index, arr) => {
          if (item.id === element.id) {
            arr.splice(index, 1);
          }
        }
      );
      this.checkedNodes = this.defaultCheckedDimensionValues[
        this.currentDimensionCode
      ];
      this.checkedOptions = this.checkedNodes;
      this.$refs.tree.setCheckedNodes(this.checkedNodes);
    },
    // 删除
    // handleRemoveChecked(){
    //   // 不被删除的插入到tree中
    //   // 深拷贝对象数组
    //   let objDeepCopy = function (source) {
    //       let sourceCopy = source instanceof Array ? [] : {};
    //       for (let item in source) {
    //           sourceCopy[item] = typeof source[item] === 'object' ? objDeepCopy(source[item]) : source[item];
    //       }
    //       return sourceCopy;
    //   }
    //   if (this.checkedOptions.length>0) {
    //     let newcheckedNodes = objDeepCopy(this.checkedNodes)
    //     let newcheckedOptions = objDeepCopy(this.checkedOptions)
    //     let set = newcheckedOptions.map(item=>item.id);
    //     newcheckedNodes = newcheckedNodes.filter(item=>!set.includes(item.id))

    //     this.defaultCheckedDimensionValues[this.currentDimensionCode] = newcheckedNodes
    //     this.checkedOptions = []
    //     this.checkedNodes = newcheckedNodes
    //     this.$refs.tree.setCheckedNodes(newcheckedNodes)
    //   }
    // },
    // 清空
    handleClearAllChecked() {
      this.checkedNodes = [];
      this.checkedOptions = [];
      this.defaultCheckedDimensionValues[this.currentDimensionCode] = [];
      this.$refs.tree.setCheckedKeys([]);
      this.isIndeterminate = false;
      this.checkAll = false;
      this.$refs.tree.setCheckedNodes([]);
    },
    // --------------------------------------------------------------------------------------华丽分割线
    // 点击上方选择按钮
    funMenuSelect(val) {
      if (val === 1) {
        // 判断维度是否达上限
        // if(this.currentDimensionNum > this.sumDimensionNum){
        //   this.$message({
        //     message: "查询的维度已达上限",
        //     type: "warning"
        //   });
        //   return
        // }
        let newParamList = [],
          ParamList = [],
          ParamList_trade = {};
        Object.entries(this.defaultCheckedDimensionValues).forEach(item => {
          newParamList.push({
            dimensionName: item[0],
            dimensionValue: item[1],
            dimensionArrayName: []
          });
        });
        newParamList.forEach(item => {
          if (item.dimensionValue.length === 0) {
            this.$message({
              message: "请选择查询维度值",
              type: "warning"
            });
            return;
          }
        });
        for (let i = 0; i < newParamList.length; i++) {
          for (let j = 0; j < newParamList[i].dimensionValue.length; j++) {
            let displayName = newParamList[i].dimensionValue[j].displayName;
            newParamList[i].dimensionArray +=
              "," + newParamList[i].dimensionValue[j].id;
            newParamList[i].dimensionArrayName.push(
              displayName
                .substr(displayName.indexOf(".") + 1)
                .replace(".", ",")
                .replace("[", "")
                .replace("]", "")
                .replace("[", "")
                .replace("]", "")
            );
          }
          newParamList[i].dimensionArray = newParamList[i].dimensionArray.slice(
            10
          );
          newParamList[i].dimensionCode = newParamList[i].dimensionName.replace(
            "id",
            "name"
          );
        }
        newParamList.forEach(item => {
          ParamList.push({
            dimensionName: item.dimensionName,
            dimensionValue: item.dimensionArray
          });
          ParamList_trade[item.dimensionName] = item.dimensionArray;
          ParamList_trade[item.dimensionCode] = item.dimensionArrayName;
        });
        // console.log(ParamList_trade,'ParamList_trade')
        // console.log(ParamList,'ParamList')
        // Object.entries(ParamList_trade).forEach(item => {
        //   // ParamList_trade[item[0]] = item[1]
        //   let everyItem = [],neweveryItem = []
        //   item[1].forEach(element => {
        //     everyItem.push(element.displayName)
        //   })
        //   everyItem.forEach(ele => {
        //     neweveryItem.push(ele.substr(ele.indexOf('.')+1).replace(".", ",").replace("[", "").replace("]", "").replace("[", "").replace("]", ""))
        //   })
        //   ParamList_trade[item[0]] = neweveryItem
        // })
        // console.log(ParamList_trade,'xiao')
        if (this.uid === "-8012" || this.uid === -8012) {
          // console.log(ParamList_trade,'进去')
          this.defalutDatalist("/tradeController/queryGrid", ParamList_trade);
        } else {
          this.defalutDatalist("/data/result/list", ParamList);
        }

        this.tableShow = true;
        this.dimensionShow = false;
        // console.log(this.defaultCheckedDimensionValues,'点击表格')
      } else if (val === 2) {
        this.transferData = [];
        this.transferChecked = [];
        this.dimensionList.forEach(item => {
          this.transferData.push({ key: item.idFiled, label: item.dimension });
        });
        this.columnDimensionCode.split(",").forEach(item => {
          this.transferChecked.push(item);
        });

        this.dialogChangeRowColumn = true;
      } else if (val === 3) {
        this.hideEmptyRows($("li.param__li:eq(2)"));
      } else if (val === 4) {
        this.hideEmptyColumns($("li.param__li:eq(3)"));
      } else if (val === 5) {
        this.initClipboard();
      } else if (val === 6) {
        this.exportExcel();
      } else if (val === 7) {
        this.chartShows = true;
        if (this.$refs.mychilds) {
          this.$refs.mychilds.drawLine_Bar(1);
        }
      }
    },
    // 查询
    async querySearch() {
      const { code, data } = await api.get("/data/result/parameterQuery", {
        structrueId: this.uid,
        query: this.paramSearch,
        idFiled: this.currentDimensionCode
      });
      if (code === 0) {
        this.panelShow = true;
        if (data.length > 0) {
          this.have = true;
          this.none = false;
          this.restaurants = new Array();
          this.checkList = new Array();
          data.forEach(d => {
            d.data.forEach(v => {
              // v.idFiled = d.idFiled;
              // v.value = v.name;
              this.restaurants.push(v);
            });
          });
          this.defaultCheckedDimensionValues[this.currentDimensionCode].forEach(
            item => {
              this.restaurants.forEach(ele => {
                if (item.id === ele.id) {
                  this.checkList.push(ele);
                }
              });
            }
          );
        } else {
          this.have = false;
          this.none = true;
        }
      }
    },
    // 参数查询
    querySearchAsync() {
      if (this.paramSearch == "") {
        this.$message({
          message: "请输入内容进行查询！",
          type: "warning"
        });
        return;
      }
      this.querySearch();
    },
    changeSearchcheckbox(checked, item) {
      if (checked) {
        this.defaultCheckedDimensionValues[this.currentDimensionCode].push(
          item
        );
        this.$refs.tree.setCheckedNodes(
          this.defaultCheckedDimensionValues[this.currentDimensionCode]
        );
      } else {
        this.defaultCheckedDimensionValues[this.currentDimensionCode].forEach(
          (ele, index, arr) => {
            if (ele.id === item.id) {
              arr.splice(index, 1);
            }
          }
        );
        this.$refs.tree.setCheckedNodes(
          this.defaultCheckedDimensionValues[this.currentDimensionCode]
        );
      }
    },
    // 隐藏ID
    hide() {
      let _this = this;
      $("body").on("mouseup", function(e) {
        let con = $("#searchkeys"),
          con2 = $("#myPanel");
        if (
          !con.is(e.target) &&
          con.has(e.target).length === 0 &&
          !con.is(e.target) &&
          con.has(e.target).length === 0
        ) {
          _this.panelShow = false;
        }
      });
    },
    // --------------------------------------------------------------------------------------华丽分割线
    // 转换行列
    transposeRowColumn() {
      if (!this.rowDimensionCode && !this.columnDimensionCode) {
        this.$message({ message: "暂无数据", type: "warning" });
        return;
      }
      //点击弹框提交的时候走这里
      let tmpArr = [];
      for (let item of this.transferData) {
        tmpArr.push(item.key);
      }
      Array.prototype.diff = function(a) {
        return this.filter(function(i) {
          return a.indexOf(i) < 0;
        });
      };
      this.rowDimensionCode = tmpArr.diff(this.transferChecked).join();
      this.columnDimensionCode = this.transferChecked.join();

      if (!this.rowDimensionCode || !this.columnDimensionCode) {
        this.$message({
          message: "不能把维度都放置在行或者列上面!",
          type: "warning"
        });
        return;
      }
      this.printDataTable(1);
      this.dialogChangeRowColumn = false;

      // delete Array.prototype.diff; //修改数据库在转换行列后计算的显示bug
    },
    // 隐藏空行
    hideEmptyRows: function(elm) {
      this.showFactTable();
      if ($(elm).attr("data-hide") == undefined) {
        let emptyRowCount = 0;
        $("#table_data tr.datarow").each(function(rIndex, row) {
          let fv = 0;
          $(row)
            .children()
            .each(function(cIndex, col) {
              if (
                $(col).attr("name") == undefined &&
                $(col).attr("class") == undefined &&
                $(col).text() != ""
              ) {
                fv += parseFloat($(col).text());
              }
            });
          if (fv == 0) {
            $(row).addClass("empty-row");
            emptyRowCount++;
          }
        });
        if (emptyRowCount == 0) {
          this.$message({ message: "当前查询数据不存在空行", type: "warning" });
          return;
        }
        $(elm)
          .children()
          .first()
          .html("显示空行");
        $(elm).attr("data-hide", "true");
      } else {
        $("#table_data tr.empty-row").removeClass("empty-row");
        $(elm)
          .children()
          .first()
          .html("隐藏空行");
        $(elm).removeAttr("data-hide");
      }
    },
    // 隐藏空列
    hideEmptyColumns: function(elm) {
      if ($(elm).attr("data-hide") == undefined) {
        var isContain = function(arr, value) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] == value) return true;
          }
          return false;
        };
        var emptyColCount = 0;
        var notEmpty = new Array();
        $("#table_data tr.datarow").each(function(index, item) {
          $(item)
            .find("td")
            .each(function(tdindex, tditem) {
              if ($.trim($(tditem).text()) != "") {
                if (!isContain(notEmpty, tdindex)) {
                  notEmpty.push(tdindex);
                }
              }
            });
        });
        //alert(notEmpty);
        $("#table_data tr.datarow").each(function(index, item) {
          $(item)
            .find("td")
            .each(function(tdindex, tditem) {
              if (!isContain(notEmpty, tdindex)) {
                $("#table_data tr.row-header").each(function(
                  rowIndex,
                  headRow
                ) {
                  if ($(headRow).find("td[colspan]").length > 0) {
                    //rowIndex > 0 &&
                    $(headRow)
                      .find("td[colspan]")
                      .each(function(colIndex, headCol) {
                        var colspan = $(headCol).attr("colspan");
                        for (var c = 0; c < colspan - 1; c++) {
                          $(headCol).after(
                            '<td disabledcolspan="true" style="text-align:center">' +
                              $(headCol).text() +
                              "</td>"
                          );
                        }
                        $(headCol)
                          .attr("enabledcolspan", colspan)
                          .removeAttr("colspan");
                      });
                  }
                  var ti = rowIndex > 0 ? tdindex - 1 : tdindex;
                  $(headRow)
                    .children()
                    .eq(ti)
                    .addClass("empty-col");
                });
                $(tditem).addClass("empty-col");
                emptyColCount++;
              }
            });
        });
        if (emptyColCount == 0) {
          this.$message({ message: "当前查询数据不存在空列", type: "warning" });
          return;
        }
        $(elm)
          .children()
          .first()
          .html("显示空列");
        $(elm).attr("data-hide", "true");
      } else {
        $("#table_data td.empty-col").removeClass("empty-col");
        $("#table_data tr.row-header").each(function(index, headRow) {
          if ($(headRow).find("td[enabledcolspan]").length > 0) {
            //test
            $(headRow)
              .find("td[enabledcolspan]")
              .each(function(tdIndex, headCol) {
                var colspan = $(headCol).attr("enabledcolspan");
                for (var c = 0; c < colspan - 1; c++) {
                  $(headCol)
                    .next("td[disabledcolspan]")
                    .detach();
                }
                $(headCol)
                  .attr("colspan", colspan)
                  .removeAttr("enabledcolspan");
              });
          }
        });
        $(elm)
          .children()
          .first()
          .html("隐藏空列");
        $(elm).removeAttr("data-hide");
      }
    },
    // 复制（初始化组件)
    initClipboard: function() {
      var clipboard = new ClipboardJS("#btnCopyTableDataText", {
        target: function() {
          return document.querySelector("#mytable");
        }
      });
      let _this = this;
      clipboard.on("success", function(e) {
        _this.$message({
          message: "已将数据表内容复制到剪贴板",
          type: "success"
        });
        clipboard.destroy();
      });
      clipboard.on("error", function(e) {
        _this.$message({ message: e, type: "error" });
        clipboard.destroy();
      });
    },
    // 导出excel
    exportExcel() {
      let time = new Date(),
        year = time.getFullYear(),
        month = time.getMonth() + 1,
        day = time.getDate();

      let name =
        $("head>title").text() +
        "" +
        $(".el-breadcrumb__item:eq(2)").text() +
        "_" +
        year +
        "" +
        month +
        "" +
        day;
      let wb = XLSX.utils.table_to_book(document.querySelector("#mytable"));

      Object.keys(wb.Sheets.Sheet1).forEach(c => {
        if (!isNaN(Number(c.substring(1))))
          wb.Sheets.Sheet1[c].s = {
            font: { sz: 10, name: "Arial", bold: true },
            alignment: { horizontal: "center", vertical: "center" }
          };
      });
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.guides {
  display: none !important;
}
.content {
  height: 82vh;
  margin: 10px;
  box-shadow: rgb(217, 217, 217) 0px 0px 20px;
}
.param__ul {
  background: #fff;
  height: 100px;
  width: 100%;
  padding-top: 11px;
  .param__li {
    font-size: 14px;
    width: 119px;
    height: 100%;
    text-align: center;
    line-height: 133px;
  }
  .param__li:hover {
    cursor: pointer;
  }
  .param__li:first-child {
    background: url("../assets/imgs/table/icon_02.png") no-repeat center 5px;
    &:hover {
      background: url("../assets/imgs/table/icon_02_hover.png") no-repeat center
        5px;
    }
  }
  .param__li:nth-child(2) {
    background: url("../assets/imgs/table/icon_04.png") no-repeat center 5px;
    &:hover {
      background: url("../assets/imgs/table/icon_04_hover.png") no-repeat center
        5px;
    }
  }
  .param__li:nth-child(3) {
    position: relative;
    background: url("../assets/imgs/table/icon_05.png") no-repeat center 5px;
    &:hover {
      background: url("../assets/imgs/table/icon_05_hover.png") no-repeat center
        5px;
    }
  }
  .param__li:nth-child(4) {
    background: url("../assets/imgs/table/icon_06.png") no-repeat center 5px;
    &:hover {
      background: url("../assets/imgs/table/icon_06_hover.png") no-repeat center
        5px;
    }
  }
  .param__li:nth-child(5) {
    background: url("../assets/imgs/table/icon_07.png") no-repeat center 5px;
    &:hover {
      background: url("../assets/imgs/table/icon_07_hover.png") no-repeat center
        5px;
    }
  }
  .param__li:nth-child(6) {
    background: url("../assets/imgs/table/icon_08.png") no-repeat center 5px;
    &:hover {
      background: url("../assets/imgs/table/icon_08_hover.png") no-repeat center
        5px;
    }
  }
  .param__li:nth-child(7) {
    background: url("../assets/imgs/table/icon_09.png") no-repeat center 5px;
    &:hover {
      background: url("../assets/imgs/table/icon_09_hover.png") no-repeat center
        5px;
    }
  }
  .param__li:nth-child(8) {
    background: url("../assets/imgs/back.png") no-repeat center 5px;
    margin-right: 100px;
    &:hover {
      background: url("../assets/imgs/back_hover.png") no-repeat center 5px;
    }
    span {
      color: black;
    }
  }
}

.mainarea {
  // border: 1px solid black;
  width: 100%;
  height: 80%;
  margin-top: 2px;
  .pull-left {
    background: #fff;
    width: 10%;
    height: 100%;
    overflow: hidden;
    .el-menu {
      margin-top: 20px;
      border-right: none;
    }
    .el-menu-item {
      height: 46px;
      line-height: 46px;
    }
    .el-menu-item.is-active {
      color: black;
    }
  }
  .pull-right {
    width: 90%;
    height: 100%;
    // border: 1px solid red;
    padding: 10px 0px 0px 10px;
    #mytable {
      width: 100%;
      height: 100%;
      background: #fff;
      overflow: auto;
    }
  }
}
table.data-table {
  width: auto;
  border-collapse: collapse;
  background: #fff;
  /deep/th,
  /deep/td {
    padding: 8px 10px;
    font-size: 14px;
  }
  /deep/td {
    white-space: nowrap;
    border: 1px solid #fff;
  }
  /deep/tr td:first-child {
    border-left: none;
  }
  /deep/tr td:last-child {
    border-right: none;
  }
  /deep/tbody tr:last-child {
    td {
      border-bottom: none;
    }
  }
  /deep/thead tr:first-child {
    td {
      border-top: none;
    }
  }
  /deep/tr.row-header {
    background-color: #dfefff;
    td {
      text-align: left;
      vertical-align: middle;
      line-height: 130%;
    }
  }
  /deep/tr.row-header .icon-datasort {
    cursor: pointer;
  }
  /deep/tr.row-header .icon-datasort i {
    color: #666;
    &:hover {
      color: #007aff;
    }
  }

  /deep/tr.datarow:nth-child(even) {
    background-color: #ffeed4;
  }
  /deep/tr.datarow .row-data {
    background-color: #dfefff;
    padding-left: 10px;
    text-align: left;
  }
  tr.empty-row,
  td.empty-col {
    display: none;
  }
  td.data-missing-del,
  td.data-abnormal-del {
    background-color: #ffd4d4;
  }
  td div.data-compute {
    color: #00a2ff;
  }
  td div.data-missing {
    color: #f53e06;
  }
  td div.data-abnormal {
    color: #00c0f7;
  }
  td span.icon-dataintro {
    padding-right: 5px;
    color: #007aff;
    cursor: pointer;
  }
  tr.datarow td {
    text-align: right;
  }
  tr.datarow td:first-child {
    text-align: left;
  }
  tr.clear-row,
  td.clear-col {
    &:hover span.btn-clear,
    &:hover span.btn-clear2 {
      display: inline-block;
    }
    span.btn-clear,
    span.btn-clear2 {
      display: none;
      cursor: pointer;
      margin-left: 3px;
      i {
        color: #666;
        font-size: inherit;
        &:hover {
          color: #f00;
        }
      }
    }
  }
}
// 维度选择
.dimension {
  width: auto;
  height: 650px;
  .dimension_left {
    // border: 1px solid darkcyan;
    width: 50%;
    height: 100%;
    .select-box {
      background: #fff;
      margin-bottom: 10px;
      padding: 11px 15px 10px;
      text-align: left;
      .searchkeys {
        position: relative;
        width: 50%;
        float: right;
        margin-top: -3px;
        .input {
          background-color: #fff;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          box-sizing: border-box;
          color: #606266;
          font-size: inherit;
          height: 28px;
          line-height: 28px;
          outline: 0;
          padding: 0 15px;
          float: left;
          width: 84%;
        }
        .input_result {
          width: 100%;
          height: 300px;
          position: absolute;
          top: 38px;
          left: 0;
          z-index: 2018;
          -webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          background: #fff;
          border-radius: 4px;
          overflow: auto;
          .popper__arrow {
            position: absolute;
            top: -16px;
            left: 8%;
            display: block;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-bottom: 8px solid #fff;
          }
          ul {
            padding: 14px;
            box-sizing: border-box;
            .el-checkbox-group {
              overflow: hidden;
              .el-checkbox {
                display: block;
                margin-bottom: 5px;
              }
            }
          }
        }
        .input_result::after {
          position: absolute;
          top: -16px;
          left: 8%;
          display: block;
          width: 0;
          height: 0;
          border: 8px solid transparent;
          border-bottom: 8px solid #fff;
        }
      }
    }
    .tree-box {
      background: #fff;
      height: 93%;
      overflow: auto;
      padding: 10px 5px;
    }
  }
  .dimension_right {
    // border: 1px solid darkcyan;
    width: 48%;
    height: 100%;
    margin-left: 10px;
    .icon-del {
      background: url(../assets/imgs/del_icon.png) no-repeat 0;
      padding: 0 20px;
      cursor: pointer;
    }
    .icon-clear {
      background: url(../assets/imgs/clear_icon.png) no-repeat 0;
      padding: 0 20px;
      float: right;
      cursor: pointer;
    }
  }
}
// 弹出框
.el-transfer__buttons {
  padding: 0 3%;
}
/deep/.el-transfer-panel {
  width: 38% !important;
}
.el-checkbox {
  margin-right: 30px;
}
</style>